import React, { useState } from 'react';
import { Alert, Badge, Button, Spinner } from 'react-bootstrap';
import { setMotivoRimborso } from '../services/api';
import MotivoRimborsoFields, { motivoRimborsoCompleto } from './MotivoRimborsoFields';
import RimborsiClienteModal from './RimborsiClienteModal';

// Dettaglio ordine: avviso "cliente con rimborsi precedenti" (se ancora da valutare) e, sugli ordini
// Rimborsati, motivo del rimborso con possibilita' di correggerlo (anche per i rimborsi storici).
function RimborsoOrdineBox({ ordine, onChanged }) {
  const [showRimborsi, setShowRimborsi] = useState(false);
  const [editing, setEditing] = useState(false);
  const [motivo, setMotivo] = useState({ motivo_rimborso: '', note_rimborso: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const salva = async () => {
    setSaving(true);
    setError(null);
    try {
      await setMotivoRimborso(ordine.id, motivo);
      setEditing(false);
      onChanged();
    } catch (err) {
      setError(err.response?.data?.detail || 'Errore durante il salvataggio del motivo.');
    } finally {
      setSaving(false);
    }
  };

  const avvisoDaValutare = ordine.rimborsi_da_valutare;
  const rimborsato = ordine.stato === 'Rimborsato';
  if (!avvisoDaValutare && !rimborsato && !ordine.decisione_rimborsi) return null;

  return (
    <div className="d-print-none mb-3">
      {avvisoDaValutare && (
        <Alert variant={ordine.rimborsi_precedenti_gravi ? 'danger' : 'secondary'} className="d-flex justify-content-between align-items-center">
          <span>
            Questo cliente ha già {ordine.rimborsi_precedenti} {ordine.rimborsi_precedenti === 1 ? 'ordine rimborsato' : 'ordini rimborsati'}: decidi se evadere o rifiutare l'ordine.
          </span>
          <Button size="sm" variant={ordine.rimborsi_precedenti_gravi ? 'danger' : 'secondary'} onClick={() => setShowRimborsi(true)}>
            Vedi rimborsi e decidi
          </Button>
        </Alert>
      )}
      {!avvisoDaValutare && ordine.decisione_rimborsi && (
        <Alert variant="info" className="py-2">
          Cliente con rimborsi precedenti: ordine <strong>{ordine.decisione_rimborsi.toLowerCase()}</strong>
          {ordine.decisione_rimborsi_at ? ` il ${new Date(ordine.decisione_rimborsi_at).toLocaleString('it-IT')}` : ''}
          {ordine.decisione_rimborsi_da ? ` (${ordine.decisione_rimborsi_da})` : ''}.
        </Alert>
      )}
      {rimborsato && (
        <Alert variant="dark">
          {error && <Alert variant="danger" className="py-1">{error}</Alert>}
          {!editing ? (
            <div className="d-flex justify-content-between align-items-start gap-2">
              <div>
                <strong>Motivo del rimborso: </strong>
                {ordine.motivo_rimborso ? <Badge bg="secondary">{ordine.motivo_rimborso}</Badge> : <span className="text-muted">Non indicato</span>}
                {ordine.data_rimborso && <small className="text-muted ms-2">({new Date(ordine.data_rimborso).toLocaleDateString('it-IT')})</small>}
                {ordine.note_rimborso && <div className="small mt-1">{ordine.note_rimborso}</div>}
              </div>
              <Button
                size="sm"
                variant="outline-dark"
                onClick={() => {
                  setMotivo({ motivo_rimborso: ordine.motivo_rimborso || '', note_rimborso: ordine.note_rimborso || '' });
                  setEditing(true);
                }}
              >
                {ordine.motivo_rimborso ? 'Modifica motivo' : 'Indica motivo'}
              </Button>
            </div>
          ) : (
            <>
              <MotivoRimborsoFields value={motivo} onChange={setMotivo} disabled={saving} />
              <div className="mt-2 d-flex gap-2">
                <Button size="sm" variant="dark" disabled={saving || !motivoRimborsoCompleto(motivo)} onClick={salva}>
                  {saving ? <Spinner as="span" animation="border" size="sm" /> : 'Salva motivo'}
                </Button>
                <Button size="sm" variant="secondary" disabled={saving} onClick={() => setEditing(false)}>Annulla</Button>
              </div>
            </>
          )}
        </Alert>
      )}
      {showRimborsi && (
        <RimborsiClienteModal
          ordine={ordine}
          onClose={() => setShowRimborsi(false)}
          onDecided={() => { setShowRimborsi(false); onChanged(); }}
        />
      )}
    </div>
  );
}

export default RimborsoOrdineBox;
